export const gridCustomization = {
    "allowColumnResizing": true,
    "allowColumnReordering": true,
    "columnAutoWidth": true,
    "columnChooser": true,
    "columnFixing": false,
    "export": true,
    "filterPanel": true,
    "filterRow": false,
    "focusedRowEnabled": false,
    "groupPanel": false,
    "headerFilter": true,
    "hoverStateEnabled": false,
    "rowAlternationEnabled": true,
    "searchPanel": true,
    "showColumnHeaders": true,
    "showColumnLines": false,
    "showRowLines": true,
    "wordWrapEnabled": false
};
export const uiCustomization = {
    "scrollingRenderAsync": false,
    "scrollRenderingMode": "standard",
    "useNative": true,
    "columnHidingEnabled": false,
    "stateStoringEnabled": true,
    "remoteOperationsSorting": true,
    "remoteOperationsPaging": true,
    "remoteOperationsFiltering": true,
    "detailsfullHeight": "300",
    "tabItemHeight": "calc(90vh - 180px)",
    "tabItemCommentsHeight": "calc(90vh - 230px)",
    "fullHeight": "calc(100vh - 140px)",
    "fullWidth": "calc(100vw - 70px)",
    "halfHeight": "calc(50vh - 74px)",
    "chartTabHeight": "calc(100vh - 125px)",
    "gridTabsHeight": "calc(100vh - 190px)",
    "gridPopupHeight": "50vh",
    "tabsWidth": "100vw",
    "scrollHeight": "100%",
    "minWidthPopup": "600",
    "scrollingMode": "virtual",
    "showScrollbar": "onHover"
}